export default "__VITE_ASSET__jIz64pzQ__"